/** Morceau de nom de fichier : sans accents, en minuscules, mots séparés par des tirets (« Système et réseaux » => systeme-et-reseaux) */
export function slugify(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
